/** @format */
import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import Loader from '@components/loader';
import { TranslationProvider } from '@context/translation-context';

const EventsPage = lazy(
  () => import(/* webpackChunkName: "events-page" */ './events-page')
);

/**
 * Build Events page.
 */
export const eventsPage = (): void => {
  /**
   * Full events page (new).
   */
  const eventsPage: HTMLElement | null = document.getElementById('events-page');
  if (eventsPage) {
    const root = createRoot(eventsPage);
    root.render(
      <Suspense fallback={<Loader />}>
        <TranslationProvider>
          <EventsPage />
        </TranslationProvider>
      </Suspense>
    );
  }
};
